import Title from 'common/data-display/Title';
import Card from 'components/common/Card';
import Button from 'components/common/buttons/Button';
import { Input } from 'components/formik_inputs';
import { Form, Formik } from 'formik';
import React, { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import {
  createLinhaPesquisa,
  deleteLinhaPesquisa,
  fetchLinhaPesquisa,
  updateLinhaPesquisa,
} from 'services/core';
import styled from 'styled-components';
import { nativeGet, titleCase } from 'utils';

const LinhaPesquisaFormPage = ({ className }) => {
  const { id } = useParams();
  const [linhaPesquisa, setLinhaPesquisa] = useState(null);
  const history = useHistory();

  const handleSubmit = (values, formik) => {
    if (id) {
      updateLinhaPesquisa(id, values).then((res) => {
        toast.success('Linha de pesquisa editada com sucesso.');
        setTimeout(() => {
          history.push('/linhas-pesquisa');
        }, 2000);
      });
    } else {
      createLinhaPesquisa(values)
        .then((res) => {
          toast.success('Linha de pesquisa cadastrada com sucesso.');
          setTimeout(() => {
            history.push('/linhas-pesquisa');
          }, 2000);
        })
        .catch((err) => {
          let errors = nativeGet(err, 'response.data', null);
          for (let name of Object.keys(errors)) {
            toast.error(titleCase(errors[name][0]));
            formik.setFieldError(name, errors[name][0]);
          }
        });
    }
  };

  useEffect(() => {
    if (id && !linhaPesquisa) {
      fetchLinhaPesquisa(id).then((res) => {
        setLinhaPesquisa(res);
      });
    }
  });

  if (id && !linhaPesquisa) {
    return <>Loading...</>;
  }

  const handleDelete = async () => {
    try {
      await deleteLinhaPesquisa(id);
      toast.info('Linha de pesquisa excluida com sucesso.');
      setTimeout(() => {
        history.push('/linhas-pesquisa');
      }, 2000);
    } catch (err) {
      return toast.error(
        'Ocorreu um erro ao excluir essa linha de pesquisa. Confira se ela não está sendo utilizada em algum curriculo.'
      );
    }
  };

  return (
    <Card className={className}>
      <Title title="Nova de Linha de Pesquisa" />
      <Formik
        initialValues={linhaPesquisa || {}}
        onSubmit={(values, formik) => handleSubmit(values, formik)}
      >
        {(formik) => {
          return (
            <Form className="form-container">
              <Input label="Nome" required name="nome" />
              <div className="save-buttons">
                <Button
                  style={
                    id ? { visibility: 'normal' } : { visibility: 'hidden' }
                  }
                  type="button"
                  onClick={() => history.push('/linhas-pesquisa')}
                >
                  Voltar
                </Button>
                <div>
                  <Button
                    style={
                      id ? { visibility: 'normal' } : { visibility: 'hidden' }
                    }
                    action="danger"
                    type="button"
                    onClick={() => handleDelete()}
                  >
                    Excluir
                  </Button>

                  <Button type="submit">Salvar</Button>
                </div>
              </div>
            </Form>
          );
        }}
      </Formik>
    </Card>
  );
};

export default styled(LinhaPesquisaFormPage)`
  .form-container {
    width: 100%;
    min-height: 100px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .save-buttons {
      width: 100%;
      display: flex;
      justify-content: space-between;
    }
  }
`;
